/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { TextField, Typography, FormControl, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InputMask from 'react-input-mask';
import './styles.scss';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
    marginTop: theme?.spacing(1.5),
  },
  label: {
    lineHeight: '30px',
  },
  Input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '0',
    },
    '& .MuiInputBase-inputSizeSmall': {
      padding: theme?.spacing(1, 1.5),
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall': {
      borderColor: '#B72755',
    },
    '& .MuiFormHelperText-marginDense': {
      margin: theme?.spacing(0.5, 0.5, 0, 0.5),
    },
    '& .masked-input-container input.masked-input': {
      borderRadius: '0',
    },
  },
}));

function CustomInput(props) {
  const {
    inputRef, onChange, ...other
  } = props;
  return (
    <InputMask
      name={props?.name}
      className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiInputBase-inputSizeSmall masked-input"
      mask={props?.maskformat}
      onChange={props?.onChange}
      value={props?.value}
    />
  );
}


export default function MaskedInput(props) {
  const {
    name, value, label, required, placeholder, variant = 'outlined', error = null, size = 'small', fullWidth, type = '', onChange, maskformat, ...others
  } = props;
  const classes = useStyles();

  return (
    <FormControl variant={variant} className={classes?.formControl}>
      <Grid container spacing={0} className="inline-masked">
        <Grid item xs={12} md={4} >
          {label &&
          <Typography
            component="p"
            className={required ? 'inputLabel required' : 'inputLabel'}
          >{label}
          </Typography>}
        </Grid>
        <Grid item xs={12} md={8} >
          <TextField
            placeholder={placeholder}
            name={name}
            onChange={onChange}
            type={type}
            size={size}
            value={value}
            fullWidth={fullWidth}
            className="masked-input-container"
            maskformat={maskformat}
            InputProps={{
            inputComponent: CustomInput,
            inputProps: { maskformat },
            }}
            {...others}
            {...(error && { error: 'true', helpertext: error })}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
}
